import React from 'react';
import { Box } from '@mui/material';

import { ContactForm } from './ContactForm';



// import { DonateQrBlock } from './DonateQrBlock';

export const DonateSection = () => (
  <Box
    
  >
       
        <ContactForm />
     
  </Box>
);
